import * as React from 'react';
import Box from '@mui/material/Box';
import Hero from './components/Hero';
import TechMarquee from './components/TechMarquee';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import FAQ from './components/FAQ';
import Highlights from './components/Highlights';

function SectionDivider() {
  return (
    <Box
      aria-hidden
      sx={{
        height: '1px',
        maxWidth: 1100,
        mx: 'auto',
        background:
          'linear-gradient(90deg, transparent, hsla(210,90%,55%,0.35), transparent)',
      }}
    />
  );
}

export default function MainPage({
  scrollToSection,
  highlightsRef,
  servicesRef,
  whyChooseUsRef,
  faqsRef,
  contactUsRef,
}) {
  return (
    <Box sx={{ overflowX: 'hidden' }}>
      <Hero
        scrollToSection={scrollToSection}
        servicesRef={servicesRef}
        contactUsRef={contactUsRef}
      />

      <TechMarquee />

      <SectionDivider />

      <div ref={servicesRef}>
        <Services />
      </div>

      <SectionDivider />

      <div ref={highlightsRef}>
        <Highlights />
      </div>

      <SectionDivider />

      <div ref={whyChooseUsRef}>
        <WhyChooseUs />
      </div>

      <SectionDivider />

      <div ref={faqsRef}>
        <FAQ />
      </div>
    </Box>
  );
}
